import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export default function ErrorState({
  title,
  message,
  onRetry,
}: ErrorStateProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 8,
      }}
    >
      <Typography variant="h5">
        {title || t("common.somethingUnexpected")}
      </Typography>
      {message ? (
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          {message}
        </Typography>
      ) : null}
      {onRetry ? (
        <Button variant="outlined" sx={{ mt: 3 }} onClick={onRetry}>
          {t("common.tryAgain")}
        </Button>
      ) : null}
    </Box>
  );
}
